/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActionFlowConfigurationDTO,
  GetAllActionFlowConfigurationsParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get configuration by ID
 */
export const getActionFlowConfiguration = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowConfigurationDTO>(
      {url: `/api/v1/action-flows/configurations/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetActionFlowConfigurationInfiniteQueryKey = (id?: string,) => {
    return [
    'infinite', `/api/v1/action-flows/configurations/${id}`
    ] as const;
    }

export const getGetActionFlowConfigurationQueryKey = (id?: string,) => {
    return [
    `/api/v1/action-flows/configurations/${id}`
    ] as const;
    }

    
export const getGetActionFlowConfigurationInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getActionFlowConfiguration>>>, TError = ActionFlowConfigurationDTO>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActionFlowConfigurationInfiniteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActionFlowConfiguration>>> = ({ signal }) => getActionFlowConfiguration(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActionFlowConfigurationInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getActionFlowConfiguration>>>
export type GetActionFlowConfigurationInfiniteQueryError = ActionFlowConfigurationDTO


export function useGetActionFlowConfigurationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActionFlowConfiguration>>>, TError = ActionFlowConfigurationDTO>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionFlowConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getActionFlowConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActionFlowConfigurationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActionFlowConfiguration>>>, TError = ActionFlowConfigurationDTO>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionFlowConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getActionFlowConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActionFlowConfigurationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActionFlowConfiguration>>>, TError = ActionFlowConfigurationDTO>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get configuration by ID
 */

export function useGetActionFlowConfigurationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActionFlowConfiguration>>>, TError = ActionFlowConfigurationDTO>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActionFlowConfigurationInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetActionFlowConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError = ActionFlowConfigurationDTO>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActionFlowConfigurationQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActionFlowConfiguration>>> = ({ signal }) => getActionFlowConfiguration(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActionFlowConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getActionFlowConfiguration>>>
export type GetActionFlowConfigurationQueryError = ActionFlowConfigurationDTO


export function useGetActionFlowConfiguration<TData = Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError = ActionFlowConfigurationDTO>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionFlowConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getActionFlowConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActionFlowConfiguration<TData = Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError = ActionFlowConfigurationDTO>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionFlowConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getActionFlowConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActionFlowConfiguration<TData = Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError = ActionFlowConfigurationDTO>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get configuration by ID
 */

export function useGetActionFlowConfiguration<TData = Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError = ActionFlowConfigurationDTO>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionFlowConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActionFlowConfigurationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update an existing configuration
 */
export const updateActionFlowConfiguration = (
    id: string,
    actionFlowConfigurationDTO: ActionFlowConfigurationDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ActionFlowConfigurationDTO>(
      {url: `/api/v1/action-flows/configurations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: actionFlowConfigurationDTO
    },
      options);
    }
  


export const getUpdateActionFlowConfigurationMutationOptions = <TError = ActionFlowConfigurationDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActionFlowConfiguration>>, TError,{id: string;data: ActionFlowConfigurationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateActionFlowConfiguration>>, TError,{id: string;data: ActionFlowConfigurationDTO}, TContext> => {

const mutationKey = ['updateActionFlowConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateActionFlowConfiguration>>, {id: string;data: ActionFlowConfigurationDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  updateActionFlowConfiguration(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateActionFlowConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof updateActionFlowConfiguration>>>
    export type UpdateActionFlowConfigurationMutationBody = ActionFlowConfigurationDTO
    export type UpdateActionFlowConfigurationMutationError = ActionFlowConfigurationDTO

    /**
 * @summary Update an existing configuration
 */
export const useUpdateActionFlowConfiguration = <TError = ActionFlowConfigurationDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActionFlowConfiguration>>, TError,{id: string;data: ActionFlowConfigurationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateActionFlowConfiguration>>,
        TError,
        {id: string;data: ActionFlowConfigurationDTO},
        TContext
      > => {

      const mutationOptions = getUpdateActionFlowConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Delete a configuration
 */
export const deleteActionFlowConfiguration = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/action-flows/configurations/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteActionFlowConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteActionFlowConfiguration>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteActionFlowConfiguration>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteActionFlowConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteActionFlowConfiguration>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteActionFlowConfiguration(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteActionFlowConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteActionFlowConfiguration>>>
    
    export type DeleteActionFlowConfigurationMutationError = unknown

    /**
 * @summary Delete a configuration
 */
export const useDeleteActionFlowConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteActionFlowConfiguration>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteActionFlowConfiguration>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteActionFlowConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get all configurations with filtering
 */
export const getAllActionFlowConfigurations = (
    params: GetAllActionFlowConfigurationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowConfigurationDTO[]>(
      {url: `/api/v1/action-flows/configurations`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAllActionFlowConfigurationsInfiniteQueryKey = (params?: GetAllActionFlowConfigurationsParams,) => {
    return [
    'infinite', `/api/v1/action-flows/configurations`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetAllActionFlowConfigurationsQueryKey = (params?: GetAllActionFlowConfigurationsParams,) => {
    return [
    `/api/v1/action-flows/configurations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllActionFlowConfigurationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>>, TError = unknown>(params: GetAllActionFlowConfigurationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllActionFlowConfigurationsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>> = ({ signal }) => getAllActionFlowConfigurations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllActionFlowConfigurationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>>
export type GetAllActionFlowConfigurationsInfiniteQueryError = unknown


export function useGetAllActionFlowConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>>, TError = unknown>(
 params: GetAllActionFlowConfigurationsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActionFlowConfigurations>>,
          TError,
          Awaited<ReturnType<typeof getAllActionFlowConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllActionFlowConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>>, TError = unknown>(
 params: GetAllActionFlowConfigurationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActionFlowConfigurations>>,
          TError,
          Awaited<ReturnType<typeof getAllActionFlowConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllActionFlowConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>>, TError = unknown>(
 params: GetAllActionFlowConfigurationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all configurations with filtering
 */

export function useGetAllActionFlowConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>>, TError = unknown>(
 params: GetAllActionFlowConfigurationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllActionFlowConfigurationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllActionFlowConfigurationsQueryOptions = <TData = Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError = unknown>(params: GetAllActionFlowConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllActionFlowConfigurationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>> = ({ signal }) => getAllActionFlowConfigurations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllActionFlowConfigurationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>>
export type GetAllActionFlowConfigurationsQueryError = unknown


export function useGetAllActionFlowConfigurations<TData = Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError = unknown>(
 params: GetAllActionFlowConfigurationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActionFlowConfigurations>>,
          TError,
          Awaited<ReturnType<typeof getAllActionFlowConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllActionFlowConfigurations<TData = Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError = unknown>(
 params: GetAllActionFlowConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActionFlowConfigurations>>,
          TError,
          Awaited<ReturnType<typeof getAllActionFlowConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllActionFlowConfigurations<TData = Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError = unknown>(
 params: GetAllActionFlowConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all configurations with filtering
 */

export function useGetAllActionFlowConfigurations<TData = Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError = unknown>(
 params: GetAllActionFlowConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActionFlowConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllActionFlowConfigurationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a new action flow configuration
 */
export const createActionFlowConfiguration = (
    actionFlowConfigurationDTO: ActionFlowConfigurationDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowConfigurationDTO>(
      {url: `/api/v1/action-flows/configurations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: actionFlowConfigurationDTO, signal
    },
      options);
    }
  


export const getCreateActionFlowConfigurationMutationOptions = <TError = ActionFlowConfigurationDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createActionFlowConfiguration>>, TError,{data: ActionFlowConfigurationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createActionFlowConfiguration>>, TError,{data: ActionFlowConfigurationDTO}, TContext> => {

const mutationKey = ['createActionFlowConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createActionFlowConfiguration>>, {data: ActionFlowConfigurationDTO}> = (props) => {
          const {data} = props ?? {};

          return  createActionFlowConfiguration(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateActionFlowConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof createActionFlowConfiguration>>>
    export type CreateActionFlowConfigurationMutationBody = ActionFlowConfigurationDTO
    export type CreateActionFlowConfigurationMutationError = ActionFlowConfigurationDTO

    /**
 * @summary Create a new action flow configuration
 */
export const useCreateActionFlowConfiguration = <TError = ActionFlowConfigurationDTO,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createActionFlowConfiguration>>, TError,{data: ActionFlowConfigurationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createActionFlowConfiguration>>,
        TError,
        {data: ActionFlowConfigurationDTO},
        TContext
      > => {

      const mutationOptions = getCreateActionFlowConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get configuration by action flow ID
 */
export const getActionFlowConfigurationByActionFlowId = (
    actionFlowId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowConfigurationDTO>(
      {url: `/api/v1/action-flows/configurations/flow/${actionFlowId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetActionFlowConfigurationByActionFlowIdInfiniteQueryKey = (actionFlowId?: string,) => {
    return [
    'infinite', `/api/v1/action-flows/configurations/flow/${actionFlowId}`
    ] as const;
    }

export const getGetActionFlowConfigurationByActionFlowIdQueryKey = (actionFlowId?: string,) => {
    return [
    `/api/v1/action-flows/configurations/flow/${actionFlowId}`
    ] as const;
    }

    
export const getGetActionFlowConfigurationByActionFlowIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>>, TError = unknown>(actionFlowId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActionFlowConfigurationByActionFlowIdInfiniteQueryKey(actionFlowId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>> = ({ signal }) => getActionFlowConfigurationByActionFlowId(actionFlowId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(actionFlowId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActionFlowConfigurationByActionFlowIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>>
export type GetActionFlowConfigurationByActionFlowIdInfiniteQueryError = unknown


export function useGetActionFlowConfigurationByActionFlowIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>>, TError = unknown>(
 actionFlowId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>,
          TError,
          Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActionFlowConfigurationByActionFlowIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>>, TError = unknown>(
 actionFlowId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>,
          TError,
          Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActionFlowConfigurationByActionFlowIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>>, TError = unknown>(
 actionFlowId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get configuration by action flow ID
 */

export function useGetActionFlowConfigurationByActionFlowIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>>, TError = unknown>(
 actionFlowId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActionFlowConfigurationByActionFlowIdInfiniteQueryOptions(actionFlowId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetActionFlowConfigurationByActionFlowIdQueryOptions = <TData = Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError = unknown>(actionFlowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActionFlowConfigurationByActionFlowIdQueryKey(actionFlowId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>> = ({ signal }) => getActionFlowConfigurationByActionFlowId(actionFlowId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(actionFlowId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActionFlowConfigurationByActionFlowIdQueryResult = NonNullable<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>>
export type GetActionFlowConfigurationByActionFlowIdQueryError = unknown


export function useGetActionFlowConfigurationByActionFlowId<TData = Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError = unknown>(
 actionFlowId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>,
          TError,
          Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActionFlowConfigurationByActionFlowId<TData = Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError = unknown>(
 actionFlowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>,
          TError,
          Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActionFlowConfigurationByActionFlowId<TData = Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError = unknown>(
 actionFlowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get configuration by action flow ID
 */

export function useGetActionFlowConfigurationByActionFlowId<TData = Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError = unknown>(
 actionFlowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionFlowConfigurationByActionFlowId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActionFlowConfigurationByActionFlowIdQueryOptions(actionFlowId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




